import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950">读者点评</h2>
          <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-xl mx-auto">
            来自飞飞漫画网真实读者的评价与反馈，漫画全集在线看体验如何？听听他们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-5xl mx-auto">
          {commentsData.map((comment) => (
            <div key={comment.id} className="bg-background-100/60 rounded-lg p-5 md:p-6">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <span className="font-medium text-sm text-foreground-900">{comment.name}</span>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <div className="flex items-center gap-0.5 mb-2">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-xs text-accent-500"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {comment.content}
                  </p>
                  <div className="flex items-center gap-4 mt-3">
                    <button type="button" className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
                      <i className="ri-thumb-up-line text-sm"></i>
                      <span>{comment.likes}</span>
                    </button>
                    <button type="button" className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
                      <i className="ri-chat-1-line text-sm"></i>
                      <span>回复</span>
                    </button>
                    <button type="button" className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
                      <i className="ri-share-forward-line text-sm"></i>
                      <span>分享</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}